import { useGlobalDIContext } from '@context/GlobalDIContext';
import { TRANSACTION_ROUTES } from '@features/transaction/routes';
import { USER_ROUTES } from '@features/user/routes';
import { useCheckAuth, useGetUserInfo } from '@features/user/states';
import { useGetClientPermission } from '@features/user/states/queries/useGetClientPermission';
import { Iconify } from '@g2-shared/components';
import WuLayoutHeaderLang from '@layout/components/WuLayoutHeaderLang';
import { WuLayoutHeaderMenuDropdown } from '@layout/components/WuLayoutHeaderMenuDropdown';
import { layoutStyle } from '@layout/styles';
import { Box, Button, Divider, Link, MenuItem } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const { VITE_APP_LOGOUT_URL } = import.meta.env;

function WuLayoutHeaderRightMenu() {
  const { TranslationAdapter } = useGlobalDIContext();
  const { isAuthenticated } = useCheckAuth();
  const { hasSubService } = useGetClientPermission(!!isAuthenticated);
  const { user } = useGetUserInfo(hasSubService('WUD'));
  const { t } = TranslationAdapter();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = !!anchorEl;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={layoutStyle.layoutHeaderRightMenu}>
      <WuLayoutHeaderLang />
      {isAuthenticated && (
        <>
          <Button
            id="profile-menu-button"
            aria-controls={open ? 'profile-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            sx={layoutStyle.headerProfileButton}
          >
            <Iconify icon="pajamas:profile" sx={layoutStyle.headerProfileIcon} />
            {user?.personalDetails.firstName} {user?.personalDetails.lastName}
            <Iconify icon="mingcute:down-fill" sx={{ ml: user ? 2 : 0 }} />
          </Button>
          <WuLayoutHeaderMenuDropdown
            id="profile-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'profile-menu-button',
            }}
          >
            {hasSubService('WUD') && (
              <>
                <RouterLink
                  style={layoutStyle.menuDropdownLink}
                  to={TRANSACTION_ROUTES.transactionHistory}
                >
                  <MenuItem onClick={handleClose}>{t('history')}</MenuItem>
                </RouterLink>
                <RouterLink
                  style={layoutStyle.menuDropdownLink}
                  to={USER_ROUTES.userPersonalDetails}
                >
                  <MenuItem onClick={handleClose}>{t('profile')}</MenuItem>
                </RouterLink>
              </>
            )}
            <Divider sx={{ minWidth: 250 }} />
            <Link href={VITE_APP_LOGOUT_URL}>
              <MenuItem sx={layoutStyle.menuDropdownLink} onClick={handleClose}>
                {t('logout')}
              </MenuItem>
            </Link>
          </WuLayoutHeaderMenuDropdown>
        </>
      )}
    </Box>
  );
}

export default WuLayoutHeaderRightMenu;
